/* tslint:disable */

declare var Object: any;
export interface SFUploadPayComponentInterface {
  "id"?: number;
}

export class SFUploadPayComponent implements SFUploadPayComponentInterface {
  "id": number;
  constructor(data?: SFUploadPayComponentInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFUploadPayComponent`.
   */
  public static getModelName() {
    return "SFUploadPayComponent";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFUploadPayComponent for dynamic purposes.
  **/
  public static factory(data: SFUploadPayComponentInterface): SFUploadPayComponent{
    return new SFUploadPayComponent(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFUploadPayComponent',
      plural: 'SFUploadPayComponents',
      path: 'SFUploadPayComponents',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFUploadPayComponent.ts